/**
 * Derive a bare origin (scheme://host:port) from a possibly path-bearing URL.
 *
 * postMessage's `targetOrigin` and the dispatcher's registered frame origin MUST be a bare origin —
 * a value carrying a path (e.g. EDITOR_URL="https://host/editor" or PREVIEW_URL=".../preview.html")
 * never matches the frame's origin, so messages are silently dropped. Use this anywhere an *_URL
 * config value is consumed as a postMessage target. Falls back to '*' when the input is empty or
 * unparseable (keeps messaging working rather than silently dropping it).
 */
export function toOrigin(url: string | undefined | null): string {
  if (!url) return '*';
  try {
    return new URL(url).origin;
  } catch {
    return '*';
  }
}
